import { Injectable } from '@angular/core';
import { AppConfig } from "../_utilities/app-config";
import { HttpClient } from "@angular/common/http";
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ApiRequestService {

  baseUrl : string = AppConfig.API_ENDPOINT;
  private messageSource = new BehaviorSubject(false);
  currentMessage = this.messageSource.asObservable();

  constructor(private http: HttpClient) { }

  userApiFunction(data : any)
  {
      return this.http.post<any>(this.baseUrl + 'user', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          console.log(data);
          return error;
        });
  }
 
   getUserDetails()
   {

      return this.http.get(this.baseUrl + 'get_user')
        .map(res => {
          let user = res;
          console.log(user);
          localStorage.setItem('currentUser', JSON.stringify(user));
           return res;
          /* console.log(user); */
          //localStorage.setItem('currentUser', JSON.stringify(user));
        });
    }

    xql_api(data : any)
  {
      return this.http.post<any>(this.baseUrl + 'nosql', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          console.log(data);
          return error;
        });
  }

  etl_api(data : any)
  {
    console.log(data);
    
      return this.http.post<any>(this.baseUrl + 'mysqlanalytics', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          console.log(data);
          return error;
        });
  }

  changeMessage(message: boolean) {
    this.messageSource.next(message)
  }

  // Sehan API's

  emr_post(data : any)
  {
      return this.http.post<any>(this.baseUrl + 'scheduler/run-schedule-csv/', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          console.log(data);
          return error;
        });
  }


  emr_get()
  {     return this.http.get(this.baseUrl + 'scheduler/run-schedule/')
        .map(res => {
          let user = res;
          console.log(user);
           return res;
          /* console.log(user); */
          //localStorage.setItem('currentUser', JSON.stringify(user));
        });
  }

  kg(data : any)
  {
     return this.http.post<any>(this.baseUrl + 'generate_KG', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
  }

  dt(data : any)
  {
     return this.http.post<any>(this.baseUrl + 'generate_DT', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
  }


  predict(data : any)
  {
     return this.http.post<any>(this.baseUrl + 'IMRPrediction', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
  }


  case(data : any)
  {
     return this.http.post<any>(this.baseUrl + 'case_Summary', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
  }

  apicaller(type : any, data : any, url : any) {
    if(type === 'post') {
        return this.http.post<any>(url, data)
        .map(response => {
          let data = response;
          console.log(data);
          return data;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
    } else {
        return this.http.get(url)
        .map(res => {
          let user = res;
          console.log(user);
          return res;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
    }
   
  }


  revenue(data : any){
    return this.http.post<any>(this.baseUrl + 'data_uploader_malaysia', data)
        .map(response => {
          let data = response;
          return data;
        }, error => {
          let data = error;
          // console.log(data);
          return error;
        });
  }

  customize_flow(data: any) {
    return this.http.post<any>(this.baseUrl+ 'lumbar_spine_flow_task', data)
    .map(response => {
      let data = response;
      // console.log(data);
      return data;
    }, error => {
      let data = error;
      // console.log(data);
      return error;
    });
  }

  pdf_flow(data: any) {
    return this.http.post<any>(this.baseUrl+ 'pdf_files_flow_task', data)
    .map(response => {
      let data = response;
      // console.log(data);
      return data;
    }, error => {
      let data = error;
      // console.log(data);
      return error;
    });
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_services/api-request.service.ts